import { useMemo } from 'react';
import useStore from './useStore';

export default function withStore(
  { mapStateToProps = () => ({}), mapDispatchToProps = null } = {},
  actions = {}
) {
  return (Component) => (props) => {
    const [state, dispatch] = useStore(mapStateToProps);

    const actionsWithDispatch = useMemo(() => {
      if (typeof mapDispatchToProps === 'function') {
        return mapDispatchToProps(dispatch);
      }

      const reduceMapDispatchToProps = (acc, [name, action]) => {
        const actionWithDispatch = (...payload) => dispatch(action(...payload));

        acc[name] = actionWithDispatch;

        return acc;
      };

      const actionsToReduce = Object.entries(mapDispatchToProps || actions);

      return actionsToReduce.reduce(reduceMapDispatchToProps, {});
    }, [mapDispatchToProps, actions, dispatch]);

    return (
      <Component
        {...props}
        {...state}
        dispatch={dispatch}
        {...actionsWithDispatch}
      />
    );
  };
}
